import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import { useScrollAnimation, useParallax } from '../hooks/useScrollAnimation';
import '../components/Services.css';
import '../components/Portfolio.css';
import './Home.css';

// Image d'arrière-plan pour la section Services
// Vous pouvez changer cette valeur pour utiliser une autre image (ex: '/IMG3.jpg', '/IMG4.jpg', etc.)
const SERVICES_BG_IMAGE = '/IMG3.jpg';

// Image d'arrière-plan pour la section Portfolio
// Vous pouvez changer cette valeur pour utiliser une autre image
const PORTFOLIO_BG_IMAGE = '/IMG4.jpg';

const Home = () => {
  useScrollAnimation();
  useParallax();

  const services = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="21" x2="9" y2="9"></line>
        </svg>
      ),
      title: "Création de Sites Web",
      description: "Sites vitrines, e-commerce et plateformes sur mesure, optimisés pour la performance et le référencement.",
      isGold: false
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
          <line x1="12" y1="18" x2="12.01" y2="18"></line>
        </svg>
      ),
      title: "Applications Mobiles",
      description: "Applications natives iOS & Android qui offrent une expérience utilisateur fluide et engageante.",
      isGold: false
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      ),
      title: "E-commerce",
      description: "Plateformes de vente en ligne complètes avec gestion des commandes, paiements et inventaire.",
      isGold: false
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
          <path d="M2 17l10 5 10-5"></path>
          <path d="M2 12l10 5 10-5"></path>
        </svg>
      ),
      title: "Design UI/UX",
      description: "Interfaces utilisateur modernes et intuitives qui améliorent l'expérience et l'engagement.",
      isGold: false
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      ),
      title: "Maintenance & Support",
      description: "Assurez la pérennité et la sécurité de vos plateformes digitales grâce à notre support technique réactif.",
      isGold: false
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
      title: "Consulting Digital",
      description: "Conseils stratégiques pour optimiser votre présence digitale et maximiser votre retour sur investissement.",
      isGold: false
    }
  ];

  const featuredProjects = [
    {
      id: 1,
      image: '/medine.png',
      title: 'Site Vitrine',
      description: 'Développement Web et mobile',
      link: 'https://medine.site'
    },
    {
      id: 2,
      image: '/afriquequiose.png',
      title: 'Application Web',
      description: 'Développement Web & Design',
      link: 'http://afriquequiose.com'
    },
    {
      id: 3,
      image: '/edencorporate.png',
      title: 'Site Vitrine',
      description: 'Développement web',
      link: 'https://www.edencorporate.com/'
    }
  ];

  return (
    <main>
      <Hero />
      
      {/* Section À propos */}
      <section id="a-propos" className="section-transition">
        <div className="container">
          <div className="about-container">
          <div className="about-image-section">
            <div className="about-image-bg" style={{ backgroundImage: `url(/IMG2.jpg)` }}></div>
            <div className="about-features-box">
              <ul className="about-features-list">
                <li>✓ Solutions digitales sur mesure</li>
                <li>✓ Technologies modernes et performantes</li>
                <li>✓ Accompagnement personnalisé</li>
                <li>✓ Support continu et réactif</li>
              </ul>
            </div>
          </div>
          
          <div className="about-content-section">
            <p className="about-subtitle">QUI SOMMES-NOUS</p>
            <h2 className="about-main-title">Solutions Innovantes pour vos Projets Digitaux</h2>
            <p className="about-tagline">Notre Approche pour Transformer vos Idées en Réalité</p>
            
            <div className="about-text-content">
              <p>
                Cybernex Services est une entreprise spécialisée dans le développement de solutions digitales 
                sur mesure. Nous transformons vos idées en expériences digitales performantes qui captivent 
                vos utilisateurs et développent votre activité.
              </p>
              <p>
                Notre équipe de développeurs expérimentés travaille avec les dernières technologies 
                pour créer des sites web, applications mobiles et plateformes e-commerce qui répondent 
                à vos besoins spécifiques et dépassent vos attentes.
              </p>
            </div>
            
            <div className="about-cta-buttons">
              <Link to="/services" className="about-cta-primary">EN SAVOIR PLUS</Link>
            </div>
          </div>
        </div>
        </div>
      </section>

      {/* Section Services */}
      <section id="services-preview" className="section-transition services-section">
        <div className="services-bg" style={{ backgroundImage: `url(${SERVICES_BG_IMAGE})` }}></div>
        <div className="container">
          <p className="services-subtitle">NOS SERVICES</p>
          <h2 className="services-title">Solutions Digitales Complètes</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className={`service-card ${service.isGold ? 'service-card-gold' : ''}`}>
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Réalisations */}
      <section id="portfolio-preview" className="section-transition">
        <div className="portfolio-bg" style={{ backgroundImage: `url(${PORTFOLIO_BG_IMAGE})` }}></div>
        <div className="container">
          <p className="portfolio-subtitle">NOS RÉALISATIONS</p>
          <h2 className="portfolio-title">Découvrez la Qualité de Notre Travail</h2>
          <div className="portfolio-grid">
            {featuredProjects.map(project => (
              <div key={project.id} className="portfolio-item fade-in">
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                  <img src={project.image} alt={project.title} />
                  <div className="portfolio-hover">
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <span>+</span>
                  </div>
                </a>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Link to="/realisations" className="cta-button">Voir toutes nos réalisations</Link>
          </div>
        </div>
      </section>

      {/* Section CTA Contact */}
      <section id="contact-cta" className="section-transition">
        <div className="container">
          <div className="contact-cta-card">
            <div className="contact-cta-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                <path d="M2 17l10 5 10-5"></path>
                <path d="M2 12l10 5 10-5"></path>
              </svg>
            </div>
            <h2 className="contact-cta-title">Prêt à Transformer Votre Entreprise ?</h2>
            <p className="contact-cta-description">Rejoignez les entreprises leaders qui utilisent nos technologies de pointe pour se démarquer</p>
            <Link to="/contact" className="contact-cta-button">
              Contactez-nous
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
